<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" >{{ isEditable ? "SET" : "VIEW" }} CONCENTRATION FOR {{ branchData.branchName }}</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
                <div>
                    <div class="form-group row" >
                        <div class="form-group col-md-3 text-center text-uppercase">
                            <label for="inputEmail4">Capital Invested</label>
                                <currency-input
                                    v-model="maxCapital"
                                    class="form-control"
                                    currency="USD"
                                    :distraction-free="{'hideNegligibleDecimalDigits' : 'true'}"

                                />
                            <!-- <input type="number" class="form-control" v-model="maxCapital"/> -->
                        </div>
                        <div class="form-group col-md-3 text-center">
                            <label for="inputEmail4">CUSIP MAX QTY (000's)</label>
                            <currency-input
                                    v-model="cusipConcentration"
                                    :precision="0"
                                    class="form-control"
                                />
                            <!-- <input type="number" class="form-control" v-model="cusipConcentration"/> -->
                        </div>
                        <div class="form-group col-md-3 text-center">
                            <label for="inputEmail4">BRANCH LIMIT ALERT</label>
                            <currency-input
                                    v-model="branchLimit"
                                    currency="USD"
                                    class="form-control"
                                    :distraction-free="{'hideNegligibleDecimalDigits' : 'true'}"

                                />
                            <!-- <input type="number" class="form-control" v-model="branchLimit"/> -->

                        </div>
                        <div class="form-group col-md-3 text-center">
                            <label for="inputEmail4">BRANCH PAR MAX  (000's)</label>
                            <currency-input
                                    v-model="branchPaxMax"
                                    :precision="0"
                                    class="form-control"
                                />
                        </div>
                    </div>
                </div>
                <div><hr></div>
                <div class="d-flex bd-highlight mt-3">
                    <div>
                        <h4 style="color: #0087D4;" v-if="isEditable">SET STATE</h4>
                        <h4 style="color: #0087D4;" v-if="!isEditable"> STATE</h4>
                    </div>
                </div>
                <div v-if="isEditable">
                    <div class="form-group row" >
                        <label for="user" class="col-sm-2 col-form-label">STATE:</label >
                        <div class="col-sm-3">
                            <select class="form-control"  v-model="stateConcentrationKey" >
                                <option v-for="state in stateConstants" :key="state.short">{{ state.short }}</option>
                            </select>
                        </div>
                        <label for="user" class="col-sm-2 col-form-label">VALUE(%):</label>
                        <div class="col-sm-3">
                            <input type="number" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control" v-model="stateConcentrationValue"/>
                        </div>
                        <button :disabled="!isEditable || !stateConcentrationValue || !stateConcentrationKey || loading" @click="checkStateConcentrationValid()" type="button" class="btn btn-primary">ADD</button>

                    </div>
                </div>
                <div class="table-responsive" style="max-height:300px;">
                    <div v-if="loading" class="loader">
                        <img src="@/assets/img/loader.svg" alt="" />
                    </div>
                    <table
                        class="table align-items-center table-flush table-hover bidtbl"
                    >
                        <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">STATE</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center" v-if="isEditable">ACTION</th>
                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                            <tr v-if="stateConcentration.length == 0">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="(stateData,index) in stateConcentration" :key="stateData.concentration">
                                <td class="text-center">{{ stateData.concentration }}</td>
                                <td class="text-center">
                                    <input v-if="isEditable" type="number" v-model="stateData.concentrationValue" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control mx-auto input-width">
                                    <span v-if="!isEditable">{{ stateData.concentrationValue }}</span>
                                </td>
                                <td v-if="isEditable">
                                    <span
                                        @click="deleteConcentration(index,'STATE')" class="cursor-pointer">
                                       <i style="color: #d65537;" class="fa fa-times"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                </div>
                <div><hr></div>
                <div  class="d-flex bd-highlight mt-3">
                    <div>
                        <h4 style="color: #0087D4;" v-if="isEditable">SET RATING</h4>
                        <h4 style="color: #0087D4;" v-if="!isEditable"> RATING</h4>
                    </div>
                </div>
                <div v-if="isEditable">
                    <div class="form-group row ml-3" >
                        <label for="user" class="mt-2">RATING FROM:</label >
                        <div class="col-sm-2">
                            <select class="form-control" @change="checkRatingRangeisValid()"  v-model="ratingConcentrationKeyFrom" >
                                <option v-for="rating in spRatingConstants" :key="rating">{{ rating }}</option>
                            </select>
                         </div>
                         <label for="user" class="mt-2">RATING TO:</label >
                        <div class="col-sm-2">
                            <select class="form-control" @change="checkRatingRangeisValid()"  v-model="ratingConcentrationKeyTo" >
                                <option v-for="rating in spRatingConstants" :key="rating">{{ rating }}</option>
                            </select>
                         </div>
                        <label for="user" class="mt-2">VALUE(%):</label>
                        <div class="col-sm-2">
                            <input type="number" oninput="javascript: if (this.value > 100) this.value = 100;" class="form-control" v-model="ratingConcentrationValue"/>
                        </div>
                        <div class="col-sm-2">
                            <button :disabled="!isEditable || !ratingConcentrationValue || !ratingConcentrationKeyFrom || !ratingConcentrationKeyTo  || loading" @click="checkRatingConcentrationValid()" type="button" class="btn btn-primary">ADD</button> 
                        </div>
                        

                    </div>
                </div>
                <div class="table-responsive" style="max-height:300px;">
                    <div v-if="loading" class="loader">
                        <img src="@/assets/img/loader.svg" alt="" />
                    </div>
                    <table
                        class="table align-items-center table-flush table-hover bidtbl"
                    >
                        <thead class="thead-light psticky">
                        <tr>
                            <th scope="col" class="sort text-center">RATING</th>
                            <th scope="col" class="sort text-center">VALUE(%)</th>
                            <th scope="col" class="sort text-center" v-if="isEditable">ACTION</th>

                        </tr>
                        </thead>
                        <tbody class="list no-cursor">
                            <tr v-if="ratingConcentration.length == 0">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="(ratingData,index) in ratingConcentration" :key="ratingData.concentration">
                                <!-- <td class="text-center">{{ ratingData.concentration }}</td> -->
                                <td class="text-center" v-if="ratingData.concentrationList">{{ ratingData.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ ratingData.concentrationList[ratingData.concentrationList.length - 1] }}</td>
                                
                                <td class="text-center">
                                    <input v-if="isEditable" type="number" oninput="javascript: if (this.value > 100) this.value = 100;" v-model="ratingData.concentrationValue"  class="form-control mx-auto input-width">
                                    <span v-if="!isEditable">{{ ratingData.concentrationValue }}</span>
                                </td>
                                <td v-if="isEditable">
                                    <span
                                        @click="deleteConcentration(index,'RATING')" class="cursor-pointer">
                                       <i style="color: #d65537;" class="fa fa-times"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                </div>             
              <div class="modal-footer bid">
                  <button type="button" class="btn btn-secondary"  @click="$emit('close')">CLOSE</button>
                  <button :disabled="loading" v-if="isEditable" type="button" class="btn btn-primary" @click="saveConcetration()">SAVE CONCENTRATION</button>
              </div>
          </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import authService from "@/authService";
import config from "@/config";
import stateConstants from "@/stateConstants";
import spRatingConstants from "@/spRatingConstants";

  export default {
      name: 'moneyLineEditmodal',
      components :{
          
      },
      props: ['branchData'],
      data() {
          return {
            loading : false,
            maxCapital : 0,
            cusipConcentration : 0,
            stateConcentrationValue : "",
            stateConcentrationKey: "",
            stateConstants: stateConstants,
            spRatingConstants:spRatingConstants,
            stateConcentration : [],
            ratingConcentration : [],
            ratingConcentrationValue : "",
            ratingConcentrationKey: "",
            ratingConcentrationKeyFrom: "",
            ratingConcentrationKeyTo: "",
            isEditable : false,
            branchLimit : 0,
            branchPaxMax : 0
          };
      },
      methods: { 
        deleteConcentration(index,mode){
            const message = `Are you sure you want to delete?`;
            this.$confirm(message,"Confirm","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                if(mode == 'STATE'){
                    this.stateConcentration.splice(index,1)
                }
                if(mode == 'RATING'){
                    this.ratingConcentration.splice(index,1)
                }
            })
        },
        checkStateConcentrationValid(){
            if(!this.maxCapital){
                this.$alert("Capital Invested is required.","","error");
                return false
            }
            if(!this.isConcentrationExist("STATE",this.stateConcentrationKey)){
                this.addToStateList();
            }
        },
        checkRatingConcentrationValid(){
            if(!this.maxCapital){
                this.$alert("Capital Invested is required.","","error");
                return false
            }
            if(!this.checkRatingOverlapped()){
                this.addToRatingList();
            }
        },
        checkRatingRangeisValid(){
            var stringArry = this.spRatingConstants;
            if(this.ratingConcentrationKeyFrom && this.ratingConcentrationKeyTo){
                var startIndex = stringArry.indexOf(this.ratingConcentrationKeyFrom);
                var endIndex = stringArry.indexOf(this.ratingConcentrationKeyTo);
                if(startIndex <= endIndex) {
                    console.log('Selected range is valid');
                } else {
                    this.$alert('From Rating should be lower than to rating',"","error");
                    this.ratingConcentrationKeyFrom = "";
                    this.ratingConcentrationKeyTo = "";
                }
            }

        },
        checkRatingOverlapped(){
            let savedRatings = [];
            this.ratingConcentration.forEach((rating) => {
                savedRatings.push(...rating.concentrationList) 
            });
            let ratingChoosed =  this.getRangeOfRatings(this.ratingConcentrationKeyFrom,this.ratingConcentrationKeyTo);
            console.log(savedRatings,ratingChoosed)

            let exists = savedRatings.some(element => ratingChoosed.includes(element));

            if(exists){
                this.$alert("Rating has already been added.","","error")
                return exists;

            }else{
                return exists;
            }
        },

        isConcentrationExist(type,value){
            var isValid = false
            if(type == 'STATE'){
                this.stateConcentration.forEach((state) => {
                    if(state.concentration == value){
                        this.$alert("State has already been added.","","error")
                        isValid = true
                    }
                })
            }
            if(type == 'RATING'){
                this.ratingConcentration.forEach((rating) => {
                    if(rating.concentration == value){
                        this.$alert("Rating has already been added.","","error")
                        isValid = true
                    }
                })
            }

            return isValid;

        },
        addToStateList(){
            this.stateConcentration.push({
                "concentrationType":"STATE",
                "concentration":this.stateConcentrationKey,
                "concentrationValue":this.stateConcentrationValue
            });
            this.stateConcentrationKey = "";
            this.stateConcentrationValue = "";
        },
        addToRatingList(){
            this.ratingConcentration.push({
                "concentrationType":"RATING",
                // "concentration":this.ratingConcentrationKey,
                "concentrationValue":this.ratingConcentrationValue,
                "concentrationList" : this.getRangeOfRatings(this.ratingConcentrationKeyFrom,this.ratingConcentrationKeyTo)
            });
            this.ratingConcentrationKeyFrom = "";
            this.ratingConcentrationKeyTo = "";
            this.ratingConcentrationValue = "";
        },
        getRangeOfRatings(datafrom,datato){
            console.log(datafrom,datato)
            var stringArry = this.spRatingConstants
            var startIndex = stringArry.indexOf(datafrom);
            var endIndex = stringArry.indexOf(datato);
            var range = [];
            if(startIndex > endIndex){
                // swap the values
                var temp = startIndex;
                startIndex = endIndex;
                endIndex = temp;
            }
            if(datafrom && datato){
                range = stringArry.slice(startIndex, endIndex + 1);
            }else{
                range = []
            }
            return range;
            },
        saveConcetration(){
            this.loading = true;
            let dataToSend = { 
                "data":[], 
                "brokerDealerId":this.branchData.brokerId,
                "branchId": this.branchData.branchId
            }
            dataToSend.data = [...this.ratingConcentration, ...this.stateConcentration];
            dataToSend.data.push({
                "concentrationType":"CUSIP",
                "concentration":null,
                "concentrationValue":this.cusipConcentration
            })
            dataToSend.data.unshift({
                "concentrationType":"MAX_CAPITAL",
                "concentration":null,
                "concentrationValue":this.maxCapital
            })
            dataToSend.data.push({
                "concentrationType":"EXCEPTION_LIMIT",
                "concentration":null,
                "concentrationValue":this.branchLimit
            })
            dataToSend.data.push({
                "concentrationType":"BRANCH_PAX_MAX",
                "concentration":null,
                "concentrationValue":this.branchPaxMax
            })

            console.log(dataToSend)

            const auth = {
               
            };
            this.$http
                .post(config.baseUrlAutoBidder + "/compliance/add-branch-concentration", dataToSend, auth)
                .then(() => {
                    this.loading = false;
                    this.$emit('close');   
                })
                .catch((e) => {
                    console.log(e);
                });
            
        }
       
      },
      created(){
        this.maxCapital = this.branchData.maxCapitalConcList.length ? this.branchData.maxCapitalConcList[0].concentrationValueDolAmt : 0
        this.stateConcentration = this.branchData.stateConcList.map(item => ({
                concentrationType: item.concentrationType,
                concentration:  item.concentration,
                concentrationValue: item.concentrationValue
            }));
        this.ratingConcentration = this.branchData.creditRatingConcList.map(item => ({
                concentrationType: item.concentrationType,
                // concentration: item.concentration,
                concentrationValue: item.concentrationValue,
                concentrationList : item.concentrationList
            }));
        if(this.branchData.cusipConcList.length)
        this.cusipConcentration = this.branchData.cusipConcList[0].concentrationValue;
        this.branchLimit = this.branchData.branchLimit;
        this.branchPaxMax = this.branchData.branchPaxMax;
      },
      mounted() {
        this.$cognitoAuth.getIdToken((err, result) => {
            if (err) {
                console.log("accessToken is not found", err);
            } else {
                console.log(err);
               
                this.accessToken = result;
                this.$cognitoAuth.getUserGroup((err, role) => {
                if (err) {
                    console.log("accessToken is not found", err);
                } else {
                    var roleArray = role.map(item => {
                        return  item.split("-")[1];
                    })
                    this.isEditable = ( roleArray.includes("BrokerDealerRiskManager") )  ? this.isEditable = true : this.isEditable = false;
                   /// this.getBranchSetting();
                }
                });
            }
        });
    },
  };
  </script>
  <style scoped>
    hr{
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .col-form-label {
        font-size: 12px;
    }
    .input-width {
        width: 100px; /* Adjust the width as needed */
    }
    .input-d i.fa-dollar-sign {
        position: absolute;
        top: 13px;
        left: 10px;
        z-index: 9999;
        color: inherit;
        font-size: 10px;
    }
</style>